import React from "react";
import Blaume from "src/assets/images/blaume.svg";
import CartBanner from "components/cart-banner";
import TieredDiscountBar from "components/tiered-discount-bar";
import * as styles from "./style.mod.scss";
import locales from "locales";

const CartHeader = ({ settings, totalCartValue, totalQuantity, discount }) => {
  const cartLoc = locales?.cart;
  return (
    <div className={styles.cartHeader}>
      {settings?.showSnippet &&
        <div className={styles.message} id="cartSnippet">
          <div className={styles.icon}><img src={Blaume} alt="blaume" /></div>
          <p className={styles.messageDesc}> {cartLoc.message}{totalQuantity}{totalQuantity > 1 ? cartLoc?.moreThanOneProd : cartLoc.messageBold}</p>
        </div>}
      {!settings?.showSnippet &&
        <CartBanner data={settings} />}
      <TieredDiscountBar data={settings} total={totalCartValue} discount={discount} discountCode={settings?.discountCode} />

    </div>
  );
};

export default CartHeader;